import React from 'react';
import { View, StyleSheet } from 'react-native';
import { setMonth, getDate, getMonth, getYear, format, isValid, parseISO } from 'date-fns';

import InputForm from './InputForm';
import PickerSelect from './PickerSelect';
import FormError from './FormError';
import FormLabel from './FormLabel';

import { composeIsoString } from '../utils/date.utils';

// type Props = {|
//   +onDateChange: (?Date) => void,
//   +date: ?Date,
//   +isEditModeEnabled: boolean,
// |};

// type Month = {|
//   value: string,
//   label: string,
// |};

// type State = {|
//   day: string,
//   month: string,
//   year: string,
//   hasPrefilledState: boolean,
// |};

const MAX_YEAR_LENGTH = 4;
const MAX_DAY_LENGTH = 2;

const validDay = (day) => {
  return day && day !== '0' && day !== '00' && (day.length === 1 || day.length === 2);
};

const monthOptions = [...Array(12).keys()].map((currentMonth) => ({
  value: String(currentMonth),
  label: format(setMonth(new Date(), currentMonth), 'MMMM'),
}));

export default class DateInput extends React.Component {
  state = {
    day: '',
    month: '',
    year: '',
    hasPrefilledState: false,
  };

  static getDerivedStateFromProps(props, state) {
    const { date, isEditModeEnabled } = props;
    if (!isEditModeEnabled) {
      return state;
    }
    if (isEditModeEnabled && date && !state.hasPrefilledState) {
      return {
        day: String(getDate(date)),
        month: String(getMonth(date)),
        year: String(getYear(date)),
        hasPrefilledState: true,
      };
    }
    return state;
  }

  componentDidUpdate(prevProps, prevState) {
    const { onDateChange } = this.props;
    const { day, month, year } = this.state;
    if (day !== prevState.day || year !== prevState.year || month !== prevState.month) {
      if (validDay(day) && month && year.length === MAX_YEAR_LENGTH) {
        const composedDate = parseISO(composeIsoString(day, month, year));
        if (isValid(composedDate)) {
          onDateChange(composedDate);
        } else {
          onDateChange('');
        }
      } else {
        onDateChange('');
      }
    }
  }

  handleDayChange = (input) => {
    const day = input.slice(0, MAX_DAY_LENGTH);
    this.setState({ day });
  };

  handleMonthChange = (month) => {
    if (month) {
      this.setState({ month });
    }
  };

  handleYearChange = (input) => {
    const year = input.slice(0, MAX_YEAR_LENGTH);
    this.setState({ year });
  };

  render() {
    const { day, month, year } = this.state;
    const { label, required, smallText, errorMessage, months, labelMonth } = this.props;
    return (
      <View style={styles.container}>
        {!!this.props.label && (
          <FormLabel label={label} required={required} smallText={smallText} />
        )}
        <View style={styles.dateFormWrapper}>
          <View style={styles.dayPickerWrapper}>
            <InputForm
              onChangeText={this.handleDayChange}
              placeholder="DD"
              autoCorrect={false}
              value={day}
              keyboardType="number-pad"
            />
          </View>
          <View style={styles.monthPickerWrapper}>
            <PickerSelect
              items={monthOptions?.map((item, index) => {
                item.label = months ? months[index].label : item.label;
                return item;
              })}
              value={month}
              onValueChange={this.handleMonthChange}
              placeholder={{ label: labelMonth ? labelMonth : 'Month' }}
            />
          </View>
          <View style={styles.yearPickerWrapper}>
            <InputForm
              onChangeText={this.handleYearChange}
              autoCorrect={false}
              value={year}
              placeholder="YYYY"
              keyboardType="number-pad"
            />
          </View>
        </View>
        {!!errorMessage && <FormError errorMessage={errorMessage} />}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  dateFormWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  dayPickerWrapper: {
    flex: 0.2,
  },
  monthPickerWrapper: {
    flex: 0.4,
  },
  yearPickerWrapper: {
    flex: 0.3,
  },
});
